const getLanguageResource = (ns, data, language) => {
  const t = (key) => {
    let edge = data.locales.edges.find(
      (e) => e.node.ns === ns && (!language || e.node.language === language),
    );
    
    return edge ? JSON.parse(edge.node.data)[key] : key;
  };

  return {
    t,
  };
};

export default getLanguageResource;